export enum TruckTransmission {
  Unknown = 0,
  Automatic = 1,
  Manual = 2
}
export const TruckTransmissionMapping: Record<TruckTransmission, string> = {
  [TruckTransmission.Unknown]: 'Unknown',
  [TruckTransmission.Automatic]: 'Automatic',
  [TruckTransmission.Manual]: 'Manual'
};
